const isCODBlocked = (state, cityCODBlockList) => {
    if (!state.consignee.cityTo || !state.sender.cityFrom) return false;
    
    return cityCODBlockList.includes(state.sender.cityFrom) || cityCODBlockList.includes(state.consignee.cityTo);
};

const isCODBlockedName = (state, cityCODBlockList) => {
    if (!state.consignee.cityTo || !state.sender.cityFrom) return '';

    let result = '';
    if (cityCODBlockList.includes(state.sender.cityFrom)) result = state.sender.cityFrom;
    if (cityCODBlockList.includes(state.consignee.cityTo)) result = state.consignee.cityTo;

    return result;
};

export default (services, dataForm, cityCODBlockList) => ({
  powerOfAttorney: false,
  typePowerOfAttorney: [
    {
      validator: (rule, value, callback) => {
        if (services.powerOfAttorney && value === "") {
          callback(new Error("Пожалуйста выберите доверенность"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  dataForTheDriver: false,
  sendTo: [
    {
      validator: (rule, value, callback) => {
        if (services.dataForTheDriver && value === "") {
          callback(new Error("Пожалуйста выберите способ"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  cashOnDelivery: false,
  cashOnDeliverySum: [
    {
      validator: (rule, value, callback) => {
        if ((dataForm.sender.cityFrom == 'Нефтекамск' || dataForm.consignee.cityTo == 'Нефтекамск') && value > 25000) {
          callback(new Error("Максимальная сумма для Нефтекамска - 25000 руб. "));
        }
        if (value > 400000) {
          callback(new Error("Максимальная сумма для наложенного платежа - 400000 руб"));
        }
        if (dataForm.services.cashOnDelivery && isCODBlocked(dataForm, cityCODBlockList)) {
          callback(new Error("Услуга недоступна для г. " + isCODBlockedName(dataForm, cityCODBlockList)));
        }
        if (services.cashOnDelivery && (value === null || value.length === 0)) {
          callback(new Error("Пожалуйста введите сумму"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  cargoRedemption: false,
  cargoRedemptionSum: [
    {
      validator: (rule, value, callback) => {
        if (services.cargoRedemption && (value === null || value.length === 0)) {
          callback(new Error("Пожалуйста введите сумму"));
        }
        if (value > 20000) {
          callback(new Error("Максимальная сумма для наложенного платежа - 20000 руб"));
        }
        if (value < 3000) {
          callback(new Error("Минимальная сумма для наложенного платежа - 3000 руб"));
        }
        callback();
      },
      type: Number,
      trigger: "blur",
    },
  ],
  whoPaysTheRansom: [
    {
      validator: (rule, value, callback) => {
        if (services.cargoRedemption && value === "") {
          callback(new Error("Пожалуйста выберите плательщика"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  returnOfDocuments: false,
});
